import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

const BasicContentLoader = ({ ...rest }) => {
    const theme = useTheme()
    return (
        <ContentLoader
            height='500'
            width='100%'
            viewBox='0 0 100% 500'
            backgroundColor={theme?.contentLoader.bgColor}
            foregroundColor={theme?.contentLoader.fgColor}
            {...rest}
        >
            {/* Simulating text loading with several slim lines */}
            <rect x='0' y='0' rx='5' ry='5' width='100%' height='15' />
            <rect x='0' y='30' rx='5' ry='5' width='100%' height='15' />
            <rect x='0' y='60' rx='5' ry='5' width='100%' height='15' />
            <rect x='0' y='90' rx='5' ry='5' width='100%' height='15' />
            <rect x='0' y='120' rx='5' ry='5' width='100%' height='15' />
            <rect x='0' y='150' rx='5' ry='5' width='100%' height='15' />
        </ContentLoader>
    )
}

export default BasicContentLoader
